window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('voice')) return

  const shopItems = document.querySelectorAll('.shop_list > li')

  shopItems.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-current')
    })
  })
})
